<div class="wrapper d-none" *ngIf="isShow == 'false'">
  <div class="page-wrapper pt-4">
    <div class="page-content pt-0 pe-2 ps-2">
      <div class="container-fluid">
        <div class="default_class">
          <div class="content-wrapper p-0">
            <div class="container-fluid">
              <div class="row">
                <div class="col-xl-12">
                  <div class="card rounded shadow-lg">
                    <div
                      class="card-header headerbg"
                      style="border-bottom: 3px solid #d8eff8"
                    >
                      <h5 class="mb-0">Programs</h5>
                    </div>
                    <div class="card-body text-center">
                      <h5>
                        Please submit your personal details to proceed for
                        Programme application!.
                      </h5>
                      <button
                        type="button"
                        class="btn btn-primary"
                        (click)="redirectToReg()"
                      >
                        Click Here
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- && isShow=='true' -->
<app-student-home
  *ngIf="roleId == 3 || roleName?.toLowerCase() === 'alumni'"
></app-student-home>
<div
  class="modal fade"
  id="alertPopup"
  tabindex="-1"
  aria-labelledby="alertPopupLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content p-3">
      <div class="modal-body">
        <div class="d-flex justify-content-between align-items-start mb-3">
          <h5 class="fw-bold">Attention!</h5>
        </div>

        <p
          *ngIf="
            courseId == '0' ||
            (message?.length > 0 && message[0]?.IS_SUBMIT == 0)
          "
        >
          Dear applicant,<br />
          To begin a new application, navigate to
          <strong>Available Programs</strong> screen to view programs on offer
          and initiate the process by clicking "Apply". If you have already
          started an application, navigate to My Application or My Short Courses
          to Resume and complete the application process.
          <!-- If an application has already been initiated,
          please navigate to
          <strong>My Application</strong> to resume the registration process.
          Kindly ensure that all required documents are uploaded to complete
          your application. Otherwise, you may initiate a new application. -->
        </p>
        <span *ngIf="message?.length > 0 && message[0]?.IS_SUBMIT == 3">
          <p>
            Dear
            <strong>{{ userData?.firstname }} {{ userData?.lastname }},</strong
            ><br />
            Your Ref: <strong>{{ userData?.ref_code }}</strong
            ><br />
            Following your application for admission into
            <strong>{{ userData?.course_name }}</strong> programme, we are
            pleased to extend you an official offer of admission.<br />
            Navigate to <strong>my application</strong> screen to accept offer
            and download your admission letter.
          </p>
        </span>
        <!-- <p>
          Please navigate to the <strong>My Student Registration</strong> under
          <strong>Studentship</strong> to begin your registration. Ensure all
          required documents are uploaded to complete the process
        </p> -->
        <div class="text-end pt-2">
          <button
            class="btn btn-save"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
